<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-payroll-tax-relief-dialog-create
          v-if="$hasPermissionTo(['create tax reliefs'])"
          :year="yearFilter"
          @created="loadTaxReliefs"
        />
      </v-col>
      <v-spacer />

      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
        class="text-right"
      >
        <setup-payroll-tax-relief-dialog-copy
          v-if="$hasPermissionTo(['create tax reliefs'])"
          :years="years"
          @created="refreshData"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-autocomplete
          v-model="yearFilter"
          clearable
          :items="years"
          label="Year Filter"
          placeholder="Filter by year"
          item-text="value"
          item-value="id"
          @change="loadTaxReliefs"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Tax Relief's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in tax relief here"
          append-icon="search"
          label="Search Tax Relief"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>
    
    <v-data-table
      :headers="headers"
      :items="filteredTaxReliefs"
      :loading="loading"
      :search="search"
      :single-expand="true"
      show-expand
    >
      <template v-slot:item="props">
        <tr>
          <td :class="props.isExpanded?'remove-bottom-border selected':'border-bottom'">
            <v-btn
              v-if="props.item.type === 'relief'"
              icon
              @click="props.expand(!props.isExpanded);"
            >
              <v-icon small> 
                {{ props.isExpanded ? 'fa-chevron-up':'fa-chevron-down' }} 
              </v-icon>
            </v-btn>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border selected':'border-bottom' ">
            <span>
              {{ props.item.code }}
            </span>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border selected':'border-bottom' ">
            <span>
              {{ props.item.name }}
            </span>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border selected text-center':'border-bottom text-center' ">
            <span>
              {{ props.item.year }}
            </span>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border selected':'border-bottom' ">
            <span>
              {{ props.item.parent_name ? props.item.parent_code + ' - ' + props.item.parent_name : '-' }}
            </span>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border selected text-right':'border-bottom text-right' ">
            <span>
              {{ currencyFormatting(props.item.amount) }}
            </span>
          </td>
          
          <td :class="props.isExpanded? 'remove-bottom-border selected text-center':'border-bottom text-center' ">
            <v-icon medium>
              {{ props.item.is_compulsory_deduction ? 'mdi mdi-check-outline text-success' : 'mdi mdi-close-outline text-danger' }}
            </v-icon>
          </td>
        
          <td :class="props.isExpanded? 'remove-bottom-border selected':'border-bottom' ">
            <span v-if="statusFilter">
              <setup-payroll-tax-relief-dialog-edit
                v-if="$hasPermissionTo(['update tax reliefs'])"
                :tax-relief="props.item"
                @updated="refreshData"
              />
              <span class="mx-1" />
              <setup-payroll-tax-relief-dialog-delete
                v-if="$hasPermissionTo(['delete tax reliefs']) && $vuetify.breakpoint.mdAndUp"
                :tax-relief="props.item"
                @deleted="refreshData"
              />
              <!-- && !['D','Du','S','Su','Q','Q-Disabled',
              'Qa18',
              'Qa18-Disabled',
              'LP-SOCSO',
              'K',
              'ZAKAT-A',
              'ZAKAT-B'].includes(props.item.code) -->
              <setup-payroll-tax-relief-dialog-delete-mobile
                v-if="$hasPermissionTo(['delete tax reliefs']) && $vuetify.breakpoint.smAndDown"
                :tax-relief="props.item"
                @deleted="refreshData"
              />
            </span>
            <span v-else>
              <setup-payroll-tax-relief-dialog-restore
                v-if="$hasPermissionTo(['restore tax reliefs']) && $vuetify.breakpoint.mdAndUp"
                :tax-relief="props.item"
                @restored="refreshData"
              />
              <setup-payroll-tax-relief-dialog-restore-mobile
                v-if="$hasPermissionTo(['restore tax reliefs']) && $vuetify.breakpoint.smAndDown"
                :tax-relief="props.item"
                @restored="refreshData"
              />
            </span>
          </td>
        </tr>
      </template>

      <template v-slot:expanded-item="{ headers,item }">
        <td
          :colspan="headers.length"
          class="pb-2"
          style="background-color: rgba(0, 0, 0, .05);"
        >
          <div
            style="background-color:white"
            class="pa-2"
          >
            <p v-html="item.description" />
          </div>
        </td>
      </template>  
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupPayrollTaxReliefDialogCreate: () => import('@/components/hris/setup/payroll/tax-relief/DialogCreate'),
      SetupPayrollTaxReliefDialogEdit: () => import('@/components/hris/setup/payroll/tax-relief/DialogEdit'),
      SetupPayrollTaxReliefDialogDelete: () => import('@/components/hris/setup/payroll/tax-relief/DialogDelete'),
      SetupPayrollTaxReliefDialogDeleteMobile: () => import('@/components/hris/setup/payroll/tax-relief/DialogDeleteMobile'),
      SetupPayrollTaxReliefDialogRestore: () => import('@/components/hris/setup/payroll/tax-relief/DialogRestore'),
      SetupPayrollTaxReliefDialogRestoreMobile: () => import('@/components/hris/setup/payroll/tax-relief/DialogRestoreMobile'),
      SetupPayrollTaxReliefDialogCopy: () => import('@/components/hris/setup/payroll/tax-relief/DialogCopy'),
    },
    data () {
      return {
        taxReliefs: [],
        trashedTaxReliefs: [],
        headers: [
          {
            text: 'Code',
            align: 'left',
            value: 'code',
          },
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Year',
            align: 'center',
            value: 'year',
          },
          {
            text: 'Under Parent',
            align: 'center',
            value: 'parent_name',
          },
          {
            text: 'Max. Amount (RM)',
            align: 'right',
            value: 'amount',
          },
          {
            text: 'Compulsory Deduction?',
            align: 'center',
            value: 'is_compulsory_deduction',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        loading: false,
        years: [],
        yearFilter: parseInt(this.$moment().format('YYYY')),
      }
    },
    computed: {
      filteredTaxReliefs () {
        return this.statusFilter ? this.taxReliefs : this.trashedTaxReliefs
      },
    },
    created () {
      this.loading = true
      
      this.loadYears()

      this.refreshData()
    },
    methods: {
      loadTaxReliefs () {
        this.loading = true

        this.$api.taxReliefs().list({ year: this.yearFilter })
          .then(response => {
            response.data.map(relief => {
              if (relief.parent_id) {
                let parent = response.data.find(parent => {
                  return parent.id === relief.parent_id
                })

                relief.parent_code = parent.code
                relief.parent_name = parent.name
              }
            })

            this.taxReliefs = _.orderBy(response.data, ['code'], ['asc'])
            this.loading = false
          })
      },
      loadTrashedTaxReliefs () {
        this.$api.taxReliefs().listTrashed({ year: this.yearFilter })
          .then(response => {
            this.trashedTaxReliefs = _.orderBy(response.data, ['code'], ['asc'])
          })
      },
      loadYears () {
        this.$api.taxReliefs().listYears()
          .then(response => {
            this.years = response.data

            this.loading = false
          })
      },
      refreshData () {
        this.loadYears()
        this.loadTaxReliefs()
        this.loadTrashedTaxReliefs()
      },
      currencyFormatting (item) {
        let value = (Math.round((item / 100) * 100) / 100).toFixed(2)
        return this.thousandSeparator(value)
      },
      thousandSeparator (amount) {
        if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
          return amount
        }
      },
    },
  }
</script>

<style scoped>
.font-calibri{
    font-family: Calibri !important;
}

.font-16{
    font-size:16px;
}

.border-bottom-light-grey{
    border-bottom:1px solid #e6e6e6;
}

.accordion-max-height{
    max-height: 36px !important;
}

.border{
    border:1px solid #e6e6e6;
}

.loading-bar >>> .v-skeleton-loader__list-item.v-skeleton-loader__bone{
    padding-left:0px
}

.selected{
  background-color: rgba(0, 0, 0, .05);
}

.remove-bottom-border {
    border-bottom: 0px !important
}

.border-bottom {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important
}
</style>
